export const VoiceOrbCondition = {
  Muted: 'muted',
  Error: 'error',
} as const;
export type VoiceOrbCondition = (typeof VoiceOrbCondition)[keyof typeof VoiceOrbCondition];
